<template>
  <workflow-request-list />
</template>
<script>
import WorkflowRequestList from '../components/WorkflowRequestList'
export default {
  name: 'WorkflowRequestHistory',
  components: {
    WorkflowRequestList
  }
}
</script>